<dojo-sidenav
  [items]="state.sidenavItems"
  logoCompact="assets/images/logo/logo-compact.svg"
  logoFull="assets/images/logo/logo-color-horizontal.svg"
  logoFullDark="assets/images/logo/logo-color-horizontal-dark.svg"
  logoAlt="ExamDojo"
  [settingsRoute]="settingsRoute"
>
  <router-outlet />
</dojo-sidenav>
